// File: src/components/layout/Header.tsx

import React from 'react';
import { AppBar, Box, Toolbar, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TokenResponse } from '@react-oauth/google';
import { useUser } from '../../context/UserContext';
import LoginButton from '../auth/LoginButton';

interface HeaderProps {
    onLoginSuccess: (tokenResponse: TokenResponse) => void;
    isLoading?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onLoginSuccess, isLoading }) => {
    const { user, logout } = useUser();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                background: 'transparent',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(255, 151, 0, 0.1)',
            }}
        >
            <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
                {/* Лого: гость -> /, пользователь -> /dashboard (можешь так сделать позднее) */}
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        fontWeight: 700,
                        background: (theme) =>
                            `linear-gradient(45deg, ${theme.palette.primary.main} 30%, #FFB347 90%)`,
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        cursor: 'pointer',
                        flexShrink: 0,
                    }}
                    onClick={() => navigate('/dashboard')}
                >
                    {t('app_name')}
                </Typography>

                <Box sx={{ flexGrow: 1, textAlign: 'center', mx: 2, display: { xs: 'none', md: 'block' } }}>
                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                        {t('header.tagline')}
                        <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' } }}>
                            {' '}{t('header.tagline_extended')}
                        </Box>
                    </Typography>
                </Box>

                <Box sx={{ minWidth: 200, textAlign: 'right', flexShrink: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 2 }}>
                        {!user ? (
                            <LoginButton
                                onSuccess={onLoginSuccess}
                                onError={() => console.error('Google Login Failed')}
                                isLoading={isLoading}
                            />
                        ) : (
                            <>
                                <Typography variant="body1" sx={{ display: { xs: 'none', sm: 'block' } }}>
                                    {t('header.hello')}, {user.name}
                                </Typography>
                                <Button variant="outlined" onClick={handleLogout}>
                                    {t('header.logout')}
                                </Button>
                            </>
                        )}
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
